import * as React from 'react';
import { Drawer, useDrawerContext } from '@swagup-com/components';
import { IconButton, Grid } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import { useAuth } from '../global/Authentication/AuthProvider';
import { useHoliday } from '../../contexts/holiday';
import { ListMenu } from './Menu';
import {
  showDashboard,
  productMenuItemList,
  companyMenuItemList,
  packsMenuItemList,
  platformMenuItemList,
  useTabsPathsMap
} from './common';
import { getFieldFromCookie } from '../../helpers/utilsCookies';
import { AccountProfile } from './SessionHandler';

const createListMenuItem = (title, subItems, onClick, path, absolute) => ({
  title,
  subItems,
  onClick,
  path,
  absolute
});

const DrawerContent = ({ menuItems }) => {
  const { login, logout, isPending, isAuthenticated } = useAuth();

  const [text, clickHandler] = isAuthenticated ? ['Log Out', logout] : ['Login / Sign Up', login];

  return (
    <Grid container direction="column" spacing={4} style={{ color: 'white' }}>
      <Grid item>
        <ListMenu
          menuItems={menuItems}
          bottomItem={isPending ? undefined : createListMenuItem(text, [], () => clickHandler())}
          bottomItemSeparation={150}
        />
      </Grid>
    </Grid>
  );
};

const DashboardSection = () => {
  const closeDrawer = useDrawerContext();
  const onClick = () => closeDrawer();

  const activeTabs = useTabsPathsMap();

  const dashboardMenu = Object.entries(activeTabs).map(([label, path]) =>
    createListMenuItem(label, undefined, onClick, path, false)
  );

  return <DrawerContent menuItems={dashboardMenu} />;
};

const RegularSection = () => {
  const { isPending, isAuthenticated } = useAuth();
  const closeDrawer = useDrawerContext();

  const onClick = () => closeDrawer();

  const generateSubItems = menuItemList =>
    menuItemList.map(item => ({
      ...item,
      description: '',
      onClick
    }));

  const isPostalReferral = getFieldFromCookie('affiliate_id') === 'postal.io';

  const regularMenu = [
    createListMenuItem('Home', undefined, onClick, '/', true),
    createListMenuItem('Product', generateSubItems(isPostalReferral ? packsMenuItemList : productMenuItemList)),
    createListMenuItem('Platform', generateSubItems(platformMenuItemList)),
    createListMenuItem('Company', generateSubItems(companyMenuItemList)),
    createListMenuItem('Pricing', undefined, onClick, '/pricing', true),
    ...(!isPending && isAuthenticated ? [createListMenuItem('Dashboard', undefined, onClick, '/')] : [])
  ];

  return <DrawerContent menuItems={regularMenu} />;
};

const MobileHeaderContent = ({ pathname, isDashboardHeader, isPending, isAuthenticated }) => {
  if (!isPending && isAuthenticated && isDashboardHeader && showDashboard(pathname)) {
    return <DashboardSection />;
  }
  if (!isPending || !isDashboardHeader || !showDashboard(pathname)) {
    return <RegularSection />;
  }
  return null;
};

const MobileHeader = ({ pathname, isDashboardHeader }) => {
  const [open, setOpen] = React.useState(false);
  const darkMode = useHoliday();
  const { isPending, isAuthenticated } = useAuth();

  return (
    <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
      {isAuthenticated && (
        <IconButton>
          <AccountProfile isDashboardHeader={isDashboardHeader} />
        </IconButton>
      )}
      <IconButton color="inherit" onClick={() => setOpen(true)}>
        <MenuIcon style={darkMode ? { fill: '#ffffff' } : undefined} />
      </IconButton>
      <Drawer
        primary
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        PaperProps={{ style: { display: 'grid' } }}
      >
        <MobileHeaderContent
          pathname={pathname}
          isDashboardHeader={isDashboardHeader}
          isPending={isPending}
          isAuthenticated={isAuthenticated}
        />
      </Drawer>
    </div>
  );
};

export default MobileHeader;
